import fetch from './index';
import { IFrom } from '@/types/achievement';


// ------------------ ACHIEVEMENT-MANAGE 成就管理
// 分页获取成就
const getAchievement = (params: Object) => fetch.axios_admin.get('/medal/page', { params });

// 添加成就
const addAchievement = (params: IFrom) => fetch.axios_admin.post('/medal', params, {
  headers: { 'Content-Type': 'multipart/form-data' },
});

// 修改成就
const editAchievement = (params: IFrom) => fetch.axios_admin.put('/medal', params, {
  headers: { 'Content-Type': 'multipart/form-data' },
});

// 删除成就
const removeAchievement = (id: string) => fetch.axios_admin.remove('/medal', { id });

// 分页获取成就分类列表
const getAchiveType = (params: Object) => fetch.axios_admin.get('/medalType/page', { params });

// 添加成就分类列表
const addAchieveType = (params: Object) => fetch.axios_admin.post('/medalType', params);

// 修改成就分类列表
const editAchieveType = (params: Object) => fetch.axios_admin.put('/medalType', params);

// 删除成就分类列表
const removeAchieveType = (id: string) => fetch.axios_admin.remove('/medalType', { id });

export default {
  getAchievement,
  addAchievement,
  editAchievement,
  removeAchievement,
  getAchiveType,
  addAchieveType,
  editAchieveType,
  removeAchieveType,
};
